module.exports = __webpack_public_path__ + "img/Nutrilon_MCM_C2_2023_11-12-23_580x312.b0c2f791.png";